// Snapshot pattern for bridging the Transportation tab (RHF) with the
// AppRecord save flow. transformCustomsDeclaration.toSchema() (via
// CuDeGoodsShipmentTransformer) reads this at save time to merge
// transportation edits into the mutation payload.
//
// Design note: this store is a single global snapshot, unlike
// goodsShipmentFormRef / goodsItemFormRef which key by shipment index
// (`Map<number, ...>`). The Transportation tab only edits
// `goodsShipment[0]` today (TransportationTransformer.toForm hardcodes
// `source.goodsShipment?.[0]`), so a single snapshot is sufficient and
// simpler. CuDeGoodsShipmentTransformer gates the merge to
// `shipmentIndex === 0` so shipments 1..N are unaffected. If the
// Transportation tab ever becomes per-shipment, migrate this store to
// `Map<number, TransportationSnapshot>` and read
// `getTransportationSnapshot(shipmentIndex)` in the transformer.

import type { TransportationForm } from '../schemas/forms/transportation';

export interface TransportationSnapshot {
  formData: TransportationForm;
  /** The record passed to TransportationTransformer.toForm() */
  original: Record<string, any>;
}

let snapshot: TransportationSnapshot | null = null;

/**
 * Store/update the transportation snapshot (called on every form change).
 *
 * @param {TransportationSnapshot} s The snapshot to store.
 */
export const setTransportationSnapshot = (s: TransportationSnapshot) => {
  snapshot = s;
};

/**
 * Get the snapshot (for toSchema at save time).
 *
 * @return {TransportationSnapshot | null} The current snapshot, or null if none.
 */
export const getTransportationSnapshot = (): TransportationSnapshot | null =>
  snapshot;

/** Clear the snapshot (on record navigation / after save). */
export const clearTransportationSnapshot = () => {
  snapshot = null;
};
